import { Button } from '@mui/material';
import * as React from 'react';

interface Props {
  accept: () => void;
}

/**
 * Renders the legal agreement the user must accept for adding a bank account
 */
export const BankAgreement: React.FC<Props> = (props) => {
  const { accept } = props;
  return (
    <div className="flex flex-col space-y-4">
      <p className="font-regular">
        By clicking Accept, you authorize BlueCargo to debit the bank account specified above for
        any amount owed for charges arising from your use of BlueCargo&apos;s services and/or
        purchase of products from BlueCargo, pursuant to BlueCargo&apos;s website and terms, until
        this authorization is revoked. You may amend or cancel this authorization at any time by
        providing notice to BlueCargo with 30 (thirty) days notice.
      </p>
      <p className="font-regular">
        If you use BlueCargo&apos;s services or purchase additional products periodically pursuant
        to BlueCargo&apos;s terms, you authorize BlueCargo to debit your bank account periodically.
        Payments that fall outside of the regular debits authorized above will only be debited after
        your authorization is obtained.
      </p>
      <Button variant="contained" onClick={accept}>
        Accept
      </Button>
    </div>
  );
};
BankAgreement.displayName = 'BankAgreement';
